module.exports = __webpack_public_path__ + "img/option1.052a9d7e.webp";